import {withRouter} from 'react-router'
import * as React from 'react'
import {Query} from '@apollo/client/react/components'
import {GET_OWN_INTAKE_QUERY} from '../queries/GET_OWN_INTAKE_QUERY'
import {intakeMetrics} from '../organisms/Intakes/intakeMetrics/calcIntakeMetrics'

export const KidsPageCheck = withRouter(
  class Page extends React.Component {
    render () {
      return (
        <Query query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
          if (loading) { return null }
          if (error || !data || !data.getOwnIntake) { window.location.reload() }
          const intake = data.getOwnIntake
          const {
            section4Started
          } = intakeMetrics(intake)

          if (!section4Started) {
            this.props.history.replace('/kids-forbidden')
            return <div />
          }

          return (
            this.props.page
          )
        }}
        </Query>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/atoms/KidsPageCheck.js